package com.xtream.composeapp.presentation.ui.navigation

import androidx.annotation.FloatRange
import androidx.compose.animation.ContentTransform
import androidx.compose.animation.core.FiniteAnimationSpec
import androidx.compose.animation.core.tween
import androidx.compose.animation.fadeIn
import androidx.compose.animation.fadeOut
import androidx.compose.animation.slideInHorizontally
import androidx.compose.animation.slideOutHorizontally
import androidx.compose.animation.togetherWith
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.material3.Scaffold
import androidx.compose.material3.windowsizeclass.ExperimentalMaterial3WindowSizeClassApi
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.IntOffset
import androidx.lifecycle.viewmodel.navigation3.rememberViewModelStoreNavEntryDecorator
import androidx.navigation3.runtime.NavEntry
import androidx.navigation3.runtime.rememberSaveableStateHolderNavEntryDecorator
import androidx.navigation3.ui.NavDisplay
import com.xtream.composeapp.LocalAppViewModelStoreOwner
import com.xtream.composeapp.data.Screen
import org.koin.compose.viewmodel.koinViewModel


@Composable
fun AppRootNavBarScreen(
    entryProvider: (Screen) -> NavEntry<Screen> ,


    ) {
    val viewModelStoreOwner =LocalAppViewModelStoreOwner.current// activity as ViewModelStoreOwner

    val rootNavViewModel: RootNavViewModel = koinViewModel(
        viewModelStoreOwner = viewModelStoreOwner?: error("no viewModelStoreOwner provided")
    )

    println(
        "root nav, rootNavViewModel.backStack: ${rootNavViewModel}, viewModelStoreOwner: $viewModelStoreOwner"
    )
    val backStack = rootNavViewModel.backStack


    fun getTransitionAnimation(isPop: Boolean=false,@FloatRange(0.0,1.0) slideFraction: Float=1f): ContentTransform {
        val animSpec:FiniteAnimationSpec<IntOffset> =tween(durationMillis = 800)
        val animSpecFade:FiniteAnimationSpec<Float> =tween(durationMillis = 800)
        return   slideInHorizontally(animSpec) { ((if (isPop) -it else it)*slideFraction).toInt() } + fadeIn(animSpecFade) togetherWith
                slideOutHorizontally(animSpec) { ((if (isPop) it else -it)*slideFraction).toInt() } + fadeOut(animSpecFade)
    }


    @OptIn(ExperimentalMaterial3WindowSizeClassApi::class)
    @Suppress("UnusedMaterial3ScaffoldPaddingParameter")
        Scaffold(
            modifier = Modifier
                .fillMaxSize(),
        ) { innerPadding ->
            NavDisplay(
                backStack = backStack,
                transitionSpec = {
                    getTransitionAnimation(slideFraction = .02f)
                },
                popTransitionSpec = {
                    getTransitionAnimation(true,slideFraction = .02f)
                },
                predictivePopTransitionSpec = {
                    getTransitionAnimation(true)
                },
                onBack = {
                    backStack.removeLastOrNull()

                },

                entryDecorators = listOf(
                    // Add the default decorators for managing scenes and saving state
                    // Add the default decorators for managing scenes and saving state
                    rememberSaveableStateHolderNavEntryDecorator(),
                    // Then add the view model store decorator
                    rememberViewModelStoreNavEntryDecorator()
                ),
                entryProvider = entryProvider
            )


    }



}


